import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { ClaimControllerApi } from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  getXtenantId,
  useBaseData,
} from "../../../utils/utils";

interface UseClaimListLiteProps {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  startDate?: string;
  endDate?: string;
  providerUuids?: Array<string>;
  insuranceUuids?: Array<string>;
  claimStatuses?: Array<string>;
  locationUuids?: Array<string>;
}

export function useClaimListLite(
  props: UseClaimListLiteProps
): useBaseData<any> {
  const prevPage = useRef<number>(props.pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination: props.pagination,
    searchKey: props.searchKey,
    prevPage,
  });

  const pageSize = getPageSize(props.searchKey, props.pagination);
  const sortData = props.gridSorting?.[0];

  return useQuery({
    queryKey: [
      "claim-list-lite",
      pageSize,
      pageIndex,
      sortData,
      props.searchKey,
      props.startDate,
      props.endDate,
      props.providerUuids,
      props.insuranceUuids,
      props.claimStatuses,
      props.locationUuids,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new ClaimControllerApi(getConfigObject())
        .getClaimListLite(
          pageIndex,
          pageSize,
          sortData?.field ?? "dateOfService",
          sortData?.sort ?? "desc",
          props.startDate,
          props.endDate,
          props.providerUuids,
          props.insuranceUuids,
          props.claimStatuses,
          props.locationUuids,
          undefined,
          props.searchKey,
          getXtenantId()
        )
        .then((res) => res?.data),
  });
}
